import { useContext } from "react";
import BryntumContext from "../context/bryntumContext.jsx";
import AuthContext from "../context/authContext.jsx";
import LeadsView from "@/react/components/entityViews/leads/LeadsView";

const LeadsPage = () => {
  const { user } = useContext(AuthContext);
  const { project } = useContext(BryntumContext);

  if (!user || !project) return null;

  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0">
      <LeadsView />
    </div>
  );
};

export default LeadsPage;
